import { render, staticRenderFns } from "./moban-list.vue?vue&type=template&id=b8410be2&"
import script from "./moban-list.vue?vue&type=script&lang=ts&"
export * from "./moban-list.vue?vue&type=script&lang=ts&"
import style0 from "./moban-list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports